<template>
  <div class="main admin g_main">
    <LayoutHeader></LayoutHeader>
    <LayoutContent>
      <!-- <div slot='content'><slot name='main'></slot></div> -->
    </LayoutContent>
    <LayoutFooter></LayoutFooter>
    <SupportBar></SupportBar>
  </div>
</template>
<style scoped>
@import "./index.css";
</style>
<script type="babel">
import LayoutHeader from '@/components/header/index';
import LayoutContent from '@/components/content/content';
import LayoutFooter from '@/components/footer/index';
import SupportBar from '@/components/supportBar/index.vue';
export default {
    components: {
    	LayoutContent,
      LayoutHeader,
      LayoutFooter,
      SupportBar,
	},
};
</script>
